import { MobileAppBridge } from 'shared/data/MobileAppBridge';

interface GetLoadSuggestionsPageUrlParams {
  withLeadingSlash?: boolean;
}

export function getLoadSuggestionsPageUrl({
  withLeadingSlash = false,
}: GetLoadSuggestionsPageUrlParams = {}): string {
  const isDriverApp = MobileAppBridge.isInjected();

  const url = isDriverApp ? 'suggested-loads' : 'suggested-loads-screen';

  return withLeadingSlash ? `/${url}` : url;
}
